import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'
import ContentHeader from 'component/utils/ContentHeader'
import DemarcateDisapprovalJustificationTable from 'component/demarcateDisapprovalJustification/DemarcateDisapprovalJustificationTable'
import DemarcateDisapprovalJustificationEditForm from 'component/demarcateDisapprovalJustification/DemarcateDisapprovalJustificationForm'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import * as demarcateDisapprovalJustificationActions from 'action/demarcateDisapprovalJustification'

class DemarcateDisapprovalJustification extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    fetchDemarcateDisapprovalJustificationList: PropTypes.func.isRequired,
    updateDemarcateDisapprovalJustification: PropTypes.func.isRequired,
    removeDemarcateDisapprovalJustification: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
  }

  state = {
    justification: { dsDemarcateDisapprovalJustification: '' },
  }

  componentDidMount() {
    this.handleFetchJustification()
  }

  handleFetchJustification = (page) => {
    const {
      auth: { user },
      fetchDemarcateDisapprovalJustificationList,
    } = this.props

    fetchDemarcateDisapprovalJustificationList(user.dsToken, page)
  }

  updateJustificationIsActive = (justification) => {
    const {
      auth: { user },
      updateDemarcateDisapprovalJustification,
    } = this.props

    const values = {
      ...justification,
      inInactive: justification.inInactive === 0 ? 1 : 0,
    }

    updateDemarcateDisapprovalJustification(user.dsToken, values)
  }

  saveDisapprovalJustification = (values) => {
    const {
      auth: { user },
      updateDemarcateDisapprovalJustification,
    } = this.props

    updateDemarcateDisapprovalJustification(user.dsToken, values)

    this.setState({
      justification: { dsDemarcateDisapprovalJustification: '' },
    })
  }

  handleEditJustification = (justification) => {
    this.setState({
      justification,
    })
  }

  handleRemoveJustification = (justification) => {
    const {
      auth: { user },
      removeDemarcateDisapprovalJustification,
    } = this.props

    const id = {
      idDemarcateDisapprovalJustification:
        justification.idDemarcateDisapprovalJustification,
    }

    removeDemarcateDisapprovalJustification(user.dsToken, id)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('menu.demarcate') },
      { title: translate('demarcate.disapproval.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  renderPagination = () => {
    const { pages } = this.props

    if (!pages || pages < 2) {
      return null
    }

    const { current, count } = this.props

    return (
      <Col className='align-center margin-top'>
        <Pagination
          getPage={this.handleFetchJustification}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  shouldRenderJustifications = () => {
    const { justifications } = this.props

    if (!justifications || justifications.length < 1) {
      return false
    }

    return true
  }

  render() {
    const { translate, justifications } = this.props
    return (
      <div>
        <ContentHeader>
          {translate('demarcate.disapproval.title')}
        </ContentHeader>

        {this.renderBreadcrumb()}

        <Grid fluid>
          {' '}
          {/* Demarcate Disapproval Justification */}
          <Col
            lg={6}
            lgOffset={3}
            md={6}
            mdOffset={3}
            sm={12}
            xs={12}
            className='margin-top'
          >
            <h4>{translate('demarcate.disapproval.title')}</h4>
          </Col>
          {this.shouldRenderJustifications() && (
            <div>
              <Col
                lg={6}
                lgOffset={3}
                md={6}
                mdOffset={3}
                sm={12}
                xs={12}
                className='align-center margin-top'
              >
                <DemarcateDisapprovalJustificationTable
                  translate={translate}
                  justifications={justifications}
                  updateJustificationIsActive={this.updateJustificationIsActive}
                  editJustification={this.handleEditJustification}
                  removeJustification={this.handleRemoveJustification}
                />
              </Col>
              {this.renderPagination()}
            </div>
          )}
          <DemarcateDisapprovalJustificationEditForm
            updateJustification={this.handleEditJustification}
            justification={this.state.justification}
            translate={translate}
            onSubmit={this.saveDisapprovalJustification}
          />
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({
  demarcateDisapprovalJustificationReducer,
  paginateReducer,
}) => ({
  justifications: demarcateDisapprovalJustificationReducer.list.records,
  error: demarcateDisapprovalJustificationReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(demarcateDisapprovalJustificationActions, dispatch)

const HomeTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(DemarcateDisapprovalJustification)

export default connect(mapStateToProps, mapDispatchToProps)(HomeTranslated)

export { DemarcateDisapprovalJustification }
